import React, { useEffect, useState } from "react";
import AppLoading from "../../../AppLoading";
import TaxonomiesService from "../../../services/TaxonomiesService/TaxonomiesService";
import { toast } from "react-toastify";
import TaxonomyForm from "../TaxonomyForm/TaxonomyForm";
import { useNavigate, useParams } from "react-router-dom";

const EditTaxonomy = (props) => {
  const {
    vocabularyName: vocabularyNameParam,
    vocabularyId: vocabularyIdParam,
    termId: termIdParam,
  } = useParams();
  const vocabularyName = props.vocabularyName ?? vocabularyNameParam;
  const vocabularyId = props.vocabularyId ?? vocabularyIdParam;
  const termId = props.termId ?? termIdParam;

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const [taxonomyTerm, setTaxonomyTerm] = useState({});

  useEffect(() => {
    async function fetchTaxonomyTerm() {
      if (typeof termId === "undefined") {
        setIsLoading(false);
        navigate("/taxonomies");
        return;
      }
      setIsLoading(true);
      const retrievedTaxonomyTerm = await TaxonomiesService.getTaxonomyTerm(termId);
      setIsLoading(false);

      if (retrievedTaxonomyTerm) {
        setTaxonomyTerm(retrievedTaxonomyTerm);
      } else {
        toast.error("Could not retrieve taxonomy term.");
        navigate("/taxonomies");
      }
    }

    fetchTaxonomyTerm();
  }, [termId, navigate]);

  async function doEditTaxonomyTerm(values) {
    values.vocabulary_id = parseInt(vocabularyId);
    values.weight = parseInt(values.weight);

    setIsLoading(true);

    const termSuccessfullyAdded = await TaxonomiesService.updateTaxonomyTerm(
      termId,
      values,
    );

    setIsLoading(false);

    if (termSuccessfullyAdded) {
      toast.success(`Successfully updated '${values.label}' taxonomy term.`);
      navigate("/taxonomies");
    } else {
      toast.error(`Failed to update '${values.label}' taxonomy term.`);
    }
  }

  if (isLoading) {
    return <AppLoading />;
  }

  return (
    <TaxonomyForm
      onSubmit={doEditTaxonomyTerm}
      vocabularyName={vocabularyName}
      defaultValues={taxonomyTerm}
    />
  );
};

export default EditTaxonomy;
